import { SimpleModal } from '@livable/saas-react-components';
import { Alert, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
const AbosorbAdjustmentsConfirmation = _ref => {
  let handleModalClose = _ref.handleModalClose,
    isExcluded = _ref.isExcluded,
    isOpen = _ref.isOpen,
    onSubmit = _ref.onSubmit;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: handleModalClose,
    isOpen: isOpen,
    noFooter: true,
    noPadding: true,
    title: t("corrections.".concat(isExcluded ? 'exclude' : 'include', "_adjustments"))
  }, /*#__PURE__*/React.createElement(Alert, {
    icon: false,
    severity: "warning",
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t("corrections.".concat(isExcluded ? 'exclude' : 'include', "_adjustments_text")))), /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.buttons
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleModalClose,
    type: "button",
    variant: "text",
    'custom-attribute': '509-allocation-utility'
  }, t('buttons.cancel')), /*#__PURE__*/React.createElement(Button, {
    onClick: onSubmit,
    type: "submit",
    variant: "contained",
    'custom-attribute': '510-allocation-utility'
  }, t("corrections.".concat(isExcluded ? 'exclude' : 'include', "_adjustments"))))));
};
export default AbosorbAdjustmentsConfirmation;